export default "__VITE_ASSET__DCrVF1Nr__"